/*=========================================================================================
  File Name: moduleCalendarState.js
  Description: Calendar Module State
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export const getDefaultState = () => {
  return {
    list: [],
    selecting: {},
    pagination: {},
    class_histories: [],
  };
};

export default getDefaultState();
